import { Component, ElementRef, EventEmitter, Input, OnInit, ViewChild, Output } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, ButtonLoader, DataTablesService, MessageService, ConfigService } from '../../../../../core';
import { ConfigEmpresa, isIdentificacaoRepresentanteNome } from '../../../../configuracoes/app/empresa';
import { RepresentanteFilter } from '../../filter';
import { representanteAtivo } from '../../situacao';
import { Representante } from '../../representante';
import { RepresentanteSearchRepresentante, representanteSearchRepresentanteToRepresentante } from '../../representante-search';
import { RepresentantePopula } from '../representante-popula';
import { RepresentantePopulavel } from '../representante-populavel';
import { RepresentanteSearchHttpService } from '../../services';
import { RepresentanteSearchOrderBy } from '../../representante-search-orderby';
import { Pessoa } from 'app/home/pessoa/pessoa';

@Component({
    selector: 'sgt-representante-popula-modal',
    templateUrl: './representante-popula-modal.component.html',
    styleUrls: ['./representante-popula-modal.component.less']
})
export class RepresentantePopulaModalComponent implements OnInit {
    configEmpresa: ConfigEmpresa;

    @Input() title = 'Adicionar representantes';
    @Input() subtitle = 'Selecione os representantes que deseja adicionar';
    @Input() entities: RepresentantePopulavel[];
    @Output() popular = new EventEmitter<Representante[]>();

    elModal: any;
    idDataTable = 'tableRepresentantePopulaModal';
    dataTable: any;
    @ViewChild('form') form: NgForm;
    isLoading: boolean;
    isLoadingFinished: boolean;
    allSelected: boolean;
    entitiesPopula: RepresentantePopula[];


    constructor(private el: ElementRef,
                private configService: ConfigService,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private representanteSearchHttpService: RepresentanteSearchHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.search();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    private clear() {
        this.entitiesPopula = [];
        this.allSelected = false;
        this.isLoadingFinished = false;
    }

    open() {
        this.clear();
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Pesquisa os representantes */
    private search() {
        this.isLoading = true;
        this.isLoadingFinished = false;

       this.searchRepresentantes()
            .then((representantes) => {
                this.createPopula(representantes);
                this.isLoading = false;
                this.isLoadingFinished = true;

                setTimeout(() => this.showTable(), 0);
            })
            .catch(() => {
                this.isLoading = false;
                this.isLoadingFinished = true;
            });
    }

    /** Pesquisa os representantes */
    private searchRepresentantes(): Promise<RepresentanteSearchRepresentante[]> {
        return new Promise<RepresentanteSearchRepresentante[]>((resolve, reject) => {
            const filter = new RepresentanteFilter();
            filter.situacoes = [representanteAtivo.id]; // Somente ativos

            let orderBy: RepresentanteSearchOrderBy;
            if (isIdentificacaoRepresentanteNome(this.configEmpresa.identificacaoRepresentante)) {
                orderBy = RepresentanteSearchOrderBy.Nome;
            } else {
                orderBy = RepresentanteSearchOrderBy.NomeFantasia;
            }

            this.representanteSearchHttpService.search(filter, orderBy, 'asc', -1, -1)
                .subscribe(
                    response => resolve(response?.representantes ?? []),
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar os representantes', error);
                        reject(error);
                    }
                );
        });
    }

    /** Cria os objetos utilizados para adicionar ok representantes */
    private createPopula(representantesSearch: RepresentanteSearchRepresentante[]) {
        this.entitiesPopula = [];
        representantesSearch?.forEach(representanteSearch => {
            const representante = representanteSearchRepresentanteToRepresentante(representanteSearch);

            const entityPopula = new RepresentantePopula(representante);
            entityPopula.exists = this.isExists(representante.id);
            this.entitiesPopula.push(entityPopula);
        });
    }

    showTable() {
        this.dataTablesService.showTable(jQuery(this.el.nativeElement).find(`#${this.idDataTable}`), this.dataTable, {
            paging: false,
            info: false,
            order: [[2, 'asc']],
            columnDefs: [
                {orderable: false, targets: 0},
            ],
            // scroller: true,
            scrollX: true
        }).then(dataTable => this.dataTable = dataTable);
    }

    /** Verifica se o representante informado já está adicionando */
    private isExists(idRepresentante: number): boolean {
        if (!this.entities) {
            return false;
        }

        for (let i = 0; i < this.entities.length; i++) {
            const entityAdicionada = this.entities[i];
            if (entityAdicionada.idRepresentante === idRepresentante) {
                return true;
            }
        }

        return false;
    }

    /** Verifica se possui algum representante para popular */
    hasEntities(): boolean {
        return this.entitiesPopula && this.entitiesPopula.length > 0;
    }

    /** Verifica se possui algum representante selecionado */
    private hasAnySelected(): boolean {
        for (let i = 0; i < this.entitiesPopula?.length; i++) {
            const entityPopula = this.entitiesPopula[i];
            if (entityPopula.selected && !entityPopula.exists) {
                return true;
            }
        }

        return false;
    }

    /** Ao alterar a opção de selecionar todos os representantes */
    onChangeAllSelected(value: boolean) {
        // Removendo o filtro do datatables para exibir todos os representantes
        this.dataTable.search('')
                        .draw(false);

        this.entitiesPopula?.forEach(entityPopula => {
            if (!entityPopula.exists) {
                entityPopula.selected = value;
            }
        });
    }

    /** Ao alterar a seleção de um representante */
    onChangeSelected() {
        let allSelected = true;
        for (let i = 0; i < this.entitiesPopula?.length; i++) {
            const entityPopula = this.entitiesPopula[i];
            if (!entityPopula.selected && !entityPopula.exists) {
                allSelected = false;
                break;
            }
        }

        this.allSelected = allSelected;
    }

    /** Adiciona os representantes selecionados */
    popularClick() {
        if (!this.hasAnySelected()) {
            this.messageService.info('Selecione pelo menos um representante para adicionar ou clique em cancelar se não desejar adicionar nenhum representante', 'Informação');
            return;
        }

        const btn = new ButtonLoader('#btnPopularUnidadeNegocioPopulaModal');
        btn.loading('Adicionando');

        const entities: Representante[] = [];
        this.entitiesPopula?.forEach(entityPopula => {
            if (entityPopula.selected && !entityPopula.exists) {
                entities.push(entityPopula.representante);
            }
        });

        btn.reset();
        this.close();

        this.popular.emit(entities);
    }
}
